import displayName from 'component-lib/displayName';
import CellBase from './CellBase';

export default class CheckboxCell extends CellBase {
    static displayName = displayName('TableView/ActiveCell');

    static defaultProps = {
        ...CellBase.defaultProps,
        cellType: 'active',
    };

    static contextTypes = CellBase.contextTypes;

    /* eslint-disable class-methods-use-this */
    renderCell() {
        return null;
    }
    /* eslint-enable class-methods-use-this */
}
